import { View, Text, Pressable, StyleSheet } from 'react-native';
import Modal from 'react-native-modal';
import Ionicons from '@expo/vector-icons/Ionicons';

// bottom sheet style replacement for Alert.alert, used to choose between camera and photo library
export default function PhotoSourceModal({ visible, onTakePhoto, onChooseFromLibrary, onClose }) {
  return (
    <Modal
      isVisible={visible}
      hasBackdrop={true}
      backdropOpacity={0.5}
      style={styles.modal}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}
    >
      <View style={styles.sheet}>
        <Text style={styles.title}>Add a photo</Text>
        <Pressable style={styles.option} onPress={onTakePhoto}>
          <Ionicons name="camera-outline" size={22} color="#674FE0" style={styles.icon} />
          <Text style={styles.optionText}>Take Photo</Text>
        </Pressable>
        <Pressable style={styles.option} onPress={onChooseFromLibrary}>
          <Ionicons name="images-outline" size={22} color="#674FE0" style={styles.icon} />
          <Text style={styles.optionText}>Choose from Library</Text>
        </Pressable>
        <Pressable style={styles.cancelButton} onPress={onClose}>
          <Text style={styles.cancelText}>Cancel</Text>
        </Pressable>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modal: {
    justifyContent: 'flex-end',
    margin: 0,
  },
  sheet: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingTop: 10,
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
  title: {
    fontSize: 14,
    color: '#888',
    textAlign: 'center',
    marginBottom: 10,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 14,
    borderTopWidth: 1,
    borderTopColor: '#eee',
  },
  icon: {
    marginRight: 12,
  },
  optionText: {
    fontSize: 16,
    color: '#25292e',
  },
  cancelButton: {
    marginTop: 10,
    paddingVertical: 14,
    alignItems: 'center',
    backgroundColor: '#F2F2F2',
    borderRadius: 8,
  },
  cancelText: {
    fontSize: 16,
    color: '#674FE0',
    fontWeight: '600',
  },
});
